<template>
  <div class="item" @click="clickEvent">
    <i class="material-symbols-outlined col-2" v-if="showImage">exit_to_app</i>
    <span class="col-10 label">{{value}}</span>
  </div>
</template>


<script>
export default {
  name: 'NavigationRuxListItem',
  props: ['value', 'onClick', 'showImage'],
  methods: {
    clickEvent: function () {
      if (this.onClick) {
        this.onClick()
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.baby-rux {
  width: 32px;
}
.item {
  padding: 8px;
  display: flex;
  cursor: pointer;
  .label {
    text-align: left;
    padding: 0 12px;
  }
  .see-all {
    text-align: center;
    width: 100%;
  }
  span {
    &:hover {
      color: #aaa;
    }
  }
}
</style>